// Dashboard

export const dashboardHeaders = [
  "Member Number",
  "Store Name",
  "Project Type",
  "Order Type",
  "Model Store",
  "Assigned MAC",
  "Project Planner",
  "Status",
  "City",
  "State",
  "Created Date",
];

export const dashboardFields = [
  "MemberNumber",
  "StoreName",
  "ProjectType",
  "OrderType",
  "ModelStoreNumber",
  "AssignedMac",
  "AssignedPlanner",
  "ProjectStatus",
  "City",
  "State",
  "CreatedDate",
];

// Additional Values
export const globalHeaders = ["Store #", "Store Name"];

export const globalFields = ["Store", "StoreName"];

// OSO - Department

export const osoDepartmentHeaders = [
  ...globalHeaders,
  "Department",
  "Selected",
  "Existing",
  "LF",
  "Adj. LF",
  "SKU Qty",
  "Adj. Cost",
  "Ext. Cost",
];

export const osoDepartmentFields = [
  ...globalFields,
  "Department",
  "SelectedPogs",
  "ExistingPogs",
  "LinealFootage",
  "AdjLineal",
  "SkuQty",
  "AdjCost",
  "ExtendedCost",
];

// OSO - Planogram

export const osoPlanogramHeaders = [
  ...globalHeaders,
  "POG Selected",
  "Planogram Name",
  "Planogram Number",
  "Hazmat Items",
  "Restricted Items",
  "Lineal Footage",
  "Adj. Lineal",
  "Department",
  "Category",
  "Region",
  "Urbanicity",
  "Core",
  "POG SKUs",
  "POG Qty",
  "Missing SKUs",
  "Qty. Multiplier",
  "Adj. Qty",
  "POG Cost",
  "Adj. Cost",
  "Ext. Cost",
  "Discount Multiplier",
  "Core %",
  "Non-Core %",
  "Dating Days",
  "Planner Notes",
  "Retailer Notes",
  "PO Number",
  "Release Status",
  "Release Date",
  "Fill In",
];

export const osoPlanogramFields = [
  ...globalFields,
  "Selected",
  "PlanogramName",
  "PlanogramNumber",
  "HazmatInd",
  "RestrictedInd",
  "LinealFootage",
  "AdjLineal",
  "DepartmentName",
  "Category",
  "Region",
  "Urbanicity",
  "Core",
  "SKUs",
  "Qty",
  "MissingSkus",
  "QtyMultiplier",
  "AdjQty",
  "Cost",
  "AdjCost",
  "ExtCost",
  "DiscMultiplier",
  "CoreDiscount",
  "NonCoreDiscount",
  "DatingDays",
  "PlannerNotes",
  "RetailerNotes",
  "PONumber",
  "ReleaseStatus",
  "ReleaseDate",
  "AllItemsFromFillIn",
];

// OSO - Items

export const osoItemHeaders = [
  ...globalHeaders,
  "Item Description",
  "Item Selected",
  "SKU",
  "Vendor",
  "Restricted",
  "Hazmat",
  "Model",
  "Core",
  "Discontinued",
  "Sub",
  "Ref",
  "UPC",
  "Pack",
  "Qty",
  "RDC Qty",
  "Missing",
  "Qty. Multiplier",
  "Adj. Qty",
  "Tier",
  "Cost",
  "Adj. Cost",
  "Ext. Cost",
  "Discount Multiplier",
  "Core %",
  "Non-Core %",
  "Dating Days",
  "PO Number",
  "Release Status",
  "Release Date",
  "Fill In",
];

export const osoItemFields = [
  ...globalFields,
  "ItemDescription",
  "SelectedItem",
  "StoreItemId",
  "VendorName",
  "Restricted",
  "Hazmat",
  "Model",
  "Core",
  "Discontinued",
  "Sub",
  "Ref",
  "UPC",
  "BreakPackType",
  "RecQty",
  "RdcQty",
  "IsMissing",
  "QtyMultiplier",
  "AdjQty",
  "Tier",
  "PogCost",
  "AdjCost",
  "ExtendedCost",
  "DiscMultiplier",
  "CoreDiscount",
  "NonCoreDiscount",
  "DatingDays",
  "PONumber",
  "ReleaseStatus",
  "ReleaseDate",
  "IsFromFillIn",
];

// Store Supplies - Planogram

export const ssPlanogramFields = [
  ...globalFields,
  "Selected",
  "PlanogramName",
  "PlanogramNumber",
  "DepartmentName",
  "Category",
  "RestrictedInd",
  "OSOSelected",
  "Region",
  "Urbanicity",
  "Qty",
  "AdjQty",
  "Cost",
  "AdjCost",
  "AcqCost",
  "PONumber",
  "ReleaseStatus",
  "ReleaseDate",
];

export const ssPlanogramHeaders = [
  ...globalHeaders,
  "POG Selected",
  "Planogram Name",
  "Planogram Number",
  "Department",
  "Category",
  "Restricted",
  "OSO Selected",
  "Region",
  "Urbanicity",
  "Qty",
  "Adj. Qty",
  "SS POG Cost",
  "Adj. Cost",
  "Acquisition Cost",
  "PO Number",
  "Release Status",
  "Release Date",
];

// Store Supplies - Item

export const ssItemFields = [
  ...globalFields,
  "VendorName",
  "StorePlanogramId",
  "ItemDescription",
  "SelectedItem",
  "SKU",
  "IsFree",
  "Restricted",
  "OSOSelected",
  "RecQty",
  "BreakPackType",
  "EachItemCost",
  "AcqCost",
  "AdjCost",
  "AdjQty",
  "Type",
  "PONumber",
  "ReleaseStatus",
  "ReleaseDate",
];

export const ssItemHeaders = [
  ...globalHeaders,
  "Vendor",
  "Planogram Number",
  "Fixture Name",
  "Item Selected",
  "SKU",
  "IsFree",
  "Restricted",
  "OSO Selected",
  "Qty",
  "Pack",
  "Member Cost",
  "Acquisition Cost",
  "Adj. Cost",
  "Adj. Qty",
  "Type",
  "PO Number",
  "Release Status",
  "Release Date",
];
